import Alpine from 'alpinejs';

Alpine.data('documents', (adminURL, type) => ({
  adminURL,
  errors: [],
  loading: false,
  showAll: false,
  items: [],
  init() {
    this.fetchDocuments();
  },
  fetchDocuments() {
    this.loading = true;

    const formData = new FormData();
    formData.append('action', 'getDocuments');
    formData.append('type', type);

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        this.loading = false;

        this.items = res;
      });
  },
}));
